module.exports = __webpack_public_path__ + "img/china.23d3307e.png";